import { render, staticRenderFns } from "./RiskAcceptanceModal.vue?vue&type=template&id=c878e854"
import script from "./RiskAcceptanceModal.vue?vue&type=script&lang=js"
export * from "./RiskAcceptanceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports